import type { SummaryResponse } from "./api-types";

export function buildUsageSummaryUrl(
  apiBase: string,
  customer: string,
  month: string,
): string {
  const url = new URL(`${apiBase.replace(/\/+$/, "")}/usage`);
  url.searchParams.set("customer", customer);
  url.searchParams.set("report", "summary");
  url.searchParams.set("month", month);
  return url.toString();
}

export async function fetchUsageSummary(
  apiBase: string,
  customer: string,
  month: string,
  token: string,
): Promise<SummaryResponse> {
  const res = await fetch(buildUsageSummaryUrl(apiBase, customer, month), {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(`API ${res.status}: ${text || res.statusText}`);
  }
  return res.json() as Promise<SummaryResponse>;
}

export function buildUsageCustomersUrl(apiBase: string): string {
  const url = new URL(`${apiBase.replace(/\/+$/, "")}/usage`);
  url.searchParams.set("report", "customers");
  return url.toString();
}

/** Staff-only: distinct customer ids from usage data (OPEN + closed segments). */
export async function fetchUsageCustomerList(
  apiBase: string,
  token: string,
): Promise<string[]> {
  const res = await fetch(buildUsageCustomersUrl(apiBase), {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(`API ${res.status}: ${text || res.statusText}`);
  }
  const data = (await res.json()) as { customers?: unknown };
  if (!Array.isArray(data.customers)) {
    throw new Error("API response missing customers array");
  }
  const out: string[] = [];
  for (const x of data.customers) {
    if (typeof x === "string") {
      const t = x.trim();
      if (t) out.push(t);
    } else if (typeof x === "number" && Number.isFinite(x)) {
      out.push(String(x));
    } else {
      throw new Error("API customers list must contain only strings or numbers");
    }
  }
  return out;
}
